import * as React from 'react';
import { BankAccountCreate, PaginationList, User } from 'core/domain';
import './create.scss';
import { getViaAuth, postViaAuth, responseValidator } from 'apis/api';
import { message, Row, Spin } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import { API } from 'apis';
import { Button, buttonType } from 'components/button/button';
import { Input, inputType } from 'components/input/input';
import { OldTxId } from 'core/domain/old-tx-ids/old-tx-ids';

const { useState } = React;

export const CreateOldTxId: React.FC = () => {
    // States
    const [loading, setLoading] = useState<boolean>(false);
    const [oldTxIdData, setOldTxIdData] = useState<OldTxId>();

    const navigate = useNavigate();

    const createOldTxId = async () => {
        setLoading(true);
        await postViaAuth(API.oldTxIds.create, oldTxIdData).then((response: any) => {
            setLoading(false);
            if (responseValidator(response.status)) {
                message.success('با موفقیت به هش های سوخته اضافه شد.');
                navigate('/dashboard/old-tx-ids/');
            }
        });
    };

    return (
        <>
            <div className="pmx-dashboard-old-tx-ids-create">
                <h3>سوزاندن هش</h3>

                <form>
                    <Input
                        label="نماد"
                        value={oldTxIdData?.coin}
                        onChange={(e) =>
                            setOldTxIdData({
                                ...oldTxIdData,
                                coin: e.target.value,
                            })
                        }
                        name="coin"
                        placeholder="نماد را وارد کنید"
                    />

                    <Input
                        label="هش"
                        value={oldTxIdData?.txId}
                        onChange={(e) =>
                            setOldTxIdData({
                                ...oldTxIdData,
                                txId: e.target.value,
                            })
                        }
                        name="txId"
                        placeholder="هش را وارد کنید"
                    />

                    <div className="buttons">
                        <Button
                            type={buttonType.info}
                            text="سوزاندن"
                            onClick={() => createOldTxId()}
                            loading={loading}
                            htmlType="button"
                            disabled={!oldTxIdData?.coin || !oldTxIdData?.txId}
                        />
                        <Button
                            type={buttonType.outlined}
                            text="بازگشت"
                            onClick={() => navigate(-1)}
                            htmlType="button"
                        />
                    </div>
                </form>
            </div>
        </>
    );
};
